module.exports = __webpack_public_path__ + "img/code1.2fb2bafe.png";